import type { ReactNode } from "react";
import "../scss/editorControls.scss";

/** Shared two-column field layout for editor inputs and compound controls. */
export function EditorField({ label, htmlFor, className = "", children }: {
  label: ReactNode;
  htmlFor?: string;
  className?: string;
  children: ReactNode;
}) {
  return <div className={`estada-editorField ${className}`}>
    <label htmlFor={htmlFor}>{label}</label>
    {children}
  </div>;
}
